import { render } from "./Actividades.vue?vue&type=template&id=fbfae0b4&scoped=true"
import script from "./Actividades.vue?vue&type=script&lang=js"
export * from "./Actividades.vue?vue&type=script&lang=js"

import "./Actividades.vue?vue&type=style&index=0&id=fbfae0b4&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.27_vue@3.5.27_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbfae0b4"]])

export default __exports__